import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { api } from "./api/client";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { configureAnalytics, measurementAllowed, track } from "./lib/analytics";
import { rememberAttribution } from "./lib/attribution";
import "./styles/index.css";

// Which tags to load is the server's call, and so is whether the query
// string an ad click landed with is remembered at all. Both are one switch,
// and the visitor holds a second one: a deployment with no campaign
// configured records nothing and loads nothing, and so does any page load
// whose browser sends Global Privacy Control. That is what the privacy
// policy (§2a) promises, and this is the line that keeps it — see
// docs/ads-campaign-2026-09.md.
//
// Attribution is read once the config answers rather than before, so that
// rule holds; the query string is still in the address bar then, because
// nothing has navigated yet. A failed request loads nothing, which is also
// what an empty config does.
api
  .authConfig()
  .then((config) => {
    if (measurementAllowed(config.analytics)) rememberAttribution();
    configureAnalytics(config.analytics);
  })
  .catch(() => {});

// Route changes are page views. The router dispatches popstate on every
// navigation it makes (router.tsx), so one listener sees them all.
window.addEventListener("popstate", () => {
  track({
    name: "page_view",
    path: window.location.pathname + window.location.search,
  });
});

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing #root");

createRoot(container).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
